import {DateTime} from 'luxon';

export default class DateTimePickerRenderer {
  constructor(container, data) {
    this.container = container;
    this.dayTemplate = document.getElementById('day-template');
    this.slotTemplate = document.getElementById('slot-template');
    this.prioritySlotHeaderTemplate = document.getElementById('priority-slot-header-template');
    this.limitedAvailabilityHeaderTemplate = document.getElementById('limited-availability-header-template');
    this.timeSlots = data.timeSlots;
    this.disabledSlots = new Set(data.disabledSlots);
    this.selectedSlots = new Set(data.selectedSlots);
    this.priorityDates = new Set(data.priorityDates || []);
    this.limitedAvailabilityDates = new Set(data.limitedAvailabilityDates || []);
    this.unpickableDates = new Set(data.unpickableDates || []);
    this.startDate = DateTime.fromISO(data.startDate);
    this.endDate = DateTime.fromISO(data.endDate);
  }

  render() {
    let index = 0;
    for (let date = this.startDate; date <= this.endDate; date = date.plus({days: 1})) {
      if (this.unpickableDates.has(date.toISODate())) continue;

      this.container.appendChild(this.buildDay(date, index));
      index++;
    }
  }

  buildDay(date, index) {
    const dayEl = this.dayTemplate.content.cloneNode(true).firstElementChild;
    const dateStr = date.toISODate();
    dayEl.id = `day-${index}`;
    dayEl.dataset.value = dateStr;
    dayEl.querySelector('.date-header').textContent = date.toFormat('dd/MM');
    dayEl.querySelector('.day-of-week-header').textContent = date.toFormat('EEEE');

    const dayHeader = dayEl.querySelector('.dtp-day-header');

    if (this.priorityDates.has(dateStr)) {
      dayEl.dataset.priority = 'true';
      dayHeader.appendChild(this.prioritySlotHeaderTemplate.content.cloneNode(true));
    }

    if (this.limitedAvailabilityDates.has(dateStr)) {
      dayEl.classList.add('limited-availability');
      dayHeader.appendChild(this.limitedAvailabilityHeaderTemplate.content.cloneNode(true));
    }

    const slotsContainer = dayEl.querySelector('.dtp-time-slots-container');
    this.timeSlots.forEach((timeStr) => {
      slotsContainer.appendChild(this.buildSlot(date, timeStr));
    });

    return dayEl;
  }

  buildSlot(date, timeStr) {
    const slotEl = this.slotTemplate.content.cloneNode(true).firstElementChild;
    const value = this.timeSlotValue(date, timeStr);
    slotEl.dataset.value = value;
    slotEl.dataset.date = date.toISODate();
    slotEl.dataset.disabled = this.disabledSlots.has(value);
    slotEl.dataset.selected = this.selectedSlots.has(value);
    slotEl.textContent = this.timeSlotLabel(timeStr);
    return slotEl;
  }

  timeSlotValue(date, timeStr) {
    const [startStr, endStr] = timeStr.split('-');
    const toTimestamp = (time) => DateTime.fromISO(`${date.toISODate()}T${time}:00`).toSeconds();
    return `${toTimestamp(startStr)}-${toTimestamp(endStr)}`;
  }

  timeSlotLabel(timeStr) {
    const [startStr, endStr] = timeStr.split('-');
    const startHour = parseInt(startStr);
    const endHour = parseInt(endStr);
    const to12 = (h) => h % 12 || 12;
    const period = startHour >= 12 ? 'PM' : 'AM';
    return `${to12(startHour)}-${to12(endHour)} ${period}`;
  }
}
